import { Component, Input } from '@angular/core';
import { CardModule } from 'primeng/card';
import { MachinePlacementItemDto } from 'src/app/shared/dtos/machine.dto';
import { PlacementContentCard } from 'src/app/core/components/placement-content-card/placement-content-card';

@Component({
  selector: 'app-view-all-content-modal',
  imports: [
    CardModule,
    PlacementContentCard
  ],
  templateUrl: './view-all-content-modal.html',
  styleUrl: './view-all-content-modal.scss'
})
export class ViewAllContentModal {
  @Input() contentToDisplay: MachinePlacementItemDto[];
}
